import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconShieldCheck: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconShieldCheck"><Path d="M9 11.25L11 13.25L15 9.25M12 2.5L20.5 5.25V11.9123C20.5 16.8848 16 19.5 12 21.6579C8 19.5 3.5 16.8848 3.5 11.9123V5.25L12 2.5Z" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconShieldCheck;
